import { INavLeftData } from '../../../types/layout';
import { Roles } from '../../../utils/constants';

export const adminNav: INavLeftData[] = [
  { name: 'Home', url: '/dashboard/', icon: 'home' },
  { type: 'devider' },
  {
    name: 'NPC by Item',
    url: '/npc/byitem/',
    icon: 'byitem',
    access: [Roles.ADMIN, Roles.SUPPORT]
  },
  {
    name: 'NPC by Brand',
    url: '/npc/bybrand/',
    icon: 'bybrand',
    access: [Roles.ADMIN, Roles.SUPPORT]
  },
  {
    name: 'FBA Freight',
    url: '/npc/fbafreight/',
    include: '/fbafreight/',
    icon: 'fbafreight',
    access: [Roles.ADMIN, Roles.SUPPORT]
  },
  {
    name: 'Storage Fee',
    url: '/npc/storage/',
    icon: 'storage',
    access: [Roles.ADMIN, Roles.SUPPORT]
  },
  {
    name: 'Inbound Freight',
    url: '/npc/inboundFreight/',
    icon: 'inboundFreight',
    access: [Roles.ADMIN, Roles.SUPPORT]
  },
  {
    name: 'Warehouse Capacity',
    url: '/warehouse/capacity/',
    include: '/warehouse/',
    icon: 'warehouse',
    access: [Roles.ADMIN, Roles.SUPPORT]
  },
  {
    name: 'Retail Store NetSuite',
    url: '/itemlookup/',
    icon: 'itemlookup'
  },
  { type: 'devider' },
  { name: 'Users', url: '/users/', icon: 'users', access: [Roles.ADMIN] }
];
